import { render, staticRenderFns } from "./MobileTalk.vue?vue&type=template&id=4d8cf504&scoped=true&"
import script from "./MobileTalk.vue?vue&type=script&lang=js&"
export * from "./MobileTalk.vue?vue&type=script&lang=js&"
import style0 from "./MobileTalk.vue?vue&type=style&index=0&id=4d8cf504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8cf504",
  null
  
)

export default component.exports